<template>
    <div>
        <div v-if="selectedDataset" id="selectedDataset" class="dataset-preview-settins">
            datasetContent
        </div>
        <div v-if="editedDataset" id="editedDataset" class="dataset-editor-area">
            <iframe id="editedDatasetArea" name="editedDatasetArea" title="Edited Dataset Area">Grid Editor</iframe>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selectedDataset', 'editedDataset'],
    name: "datasetDetails"
};
</script>
